

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadInternshipNotifications
// GETUNREADINTERNSHIPNOTIFICATIONS   

const GETUNREADINTERNSHIPNOTIFICATIONS= createAsyncThunk(
  "getUnreadInternshipNotifications/getUnreadInternshipNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadInternshipNotificationsSlice = createSlice({
  name: "getUnreadInternshipNotificationsSlice",
  initialState: {
    getUnreadInternshipNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadInternshipNotifications: (state) => {
        state.getUnreadInternshipNotifications.loading = false
        state.getUnreadInternshipNotifications.error = false
        state.getUnreadInternshipNotifications.data = []
        state.getUnreadInternshipNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADINTERNSHIPNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadInternshipNotifications = {
        ...state.getUnreadInternshipNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADINTERNSHIPNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadInternshipNotifications = {
        ...state.getUnreadInternshipNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADINTERNSHIPNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadInternshipNotifications = {
        ...state.getUnreadInternshipNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadInternshipNotificationsAction = {
    GETUNREADINTERNSHIPNOTIFICATIONS,
};

export { getUnreadInternshipNotificationsAction };
export default getUnreadInternshipNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadInternshipNotifications} = getUnreadInternshipNotificationsSlice.actions